import React from 'react';
import Constants from "./../../constants/Constants";
import Player from "./Player";
import NavTools from '../../../tools/NavTools';
import '../../PlayerStatusPopup.css';

class UserPlayer extends Player {
    constructor(gameCtx, entityIndex, args) {
        super(gameCtx, entityIndex, args);

        this.setUserEvent();

        this.waitingEvent = [];
        this.waitingEntities = [];

        this.cardSideShown = true;
    }

    subscribePlayMethod = (playMethod, singleTimeUse = false, overridePlay = false) => {
        if (typeof playMethod != "function") {
            console.log("ERROR: subscribePlayMethod has failed because playMethod is not a function");
            return;
        }
        this.overridePlay = { override: overridePlay, singleTimeUse: singleTimeUse, fn: playMethod };
    }

    endTurn = async () => {
        let enemies = this.gameCtx.gameSeqHandler.getAllCurrentEntityEnemies();
        enemies.forEach(entity => entity.standInToPrevStandOutCard());

        this.standInToPrevStandOutCard(); // TODO: Decide if to throw prevStandout or random cards.

        // //Resolve this.popupEvent promise objects
        if (this.popupEvent) {
            while (!this.popupEvent.isDone) {
                this.resolvePopupEvent();
                await this.gameCtx.waitFor(1000);
            }
        }

        while (!this.userEvent.isDone) {
            this.resolvePlayer();
            await this.gameCtx.waitFor(1000);
        }

        for (let i = 0; i < this.waitingEntities.length; i++) {
            if (!this.waitingEntities[i].userEvent.isDone) {
                this.waitingEntities[i].resolvePlayer();
                await this.gameCtx.waitFor(1000);
            }
        }
        this.waitingEntities = [];

        // //

        while (!this.userEvent.isDone) {
            this.resolvePlayer();
            await this.gameCtx.waitFor(1000);
        }

        await this.gameCtx.waitFor(1000);

        for (let i = 0; i < this.waitingEntities.length; i++) {
            if (!this.waitingEntities[i].userEvent.isDone) {
                this.waitingEntities[i].resolvePlayer();
                await this.gameCtx.waitFor(1000);
            }
        }
        this.waitingEntities = [];

        //

        this.unsubscribeEventToCards();
        this.standInToPrevStandOutCard();
        this.resolvePlayerFinal();
    }

    play = async () => {
        this.resetSelectedProperties();

        if (this.overridePlay.override) {
            if (this.overridePlay.singleTimeUse === true) { this.overridePlay.override = false; }
            return await this.overridePlay.fn();
        }

        let newPile = this.gameCtx.entitiesRepo.getNewPile();
        let usedPile = this.gameCtx.entitiesRepo.getUsedPile();

        this.addBubbleOnPile("בחר קלף", Constants.ELEMENT_NEW_PILE_PICK_A_CARD, newPile);

        let entities = [usedPile, newPile];
        let entityEvents = [];
        this.waitingEntities = [];
        let cards = []
        let chosenCard;

        entities.forEach((entity) => {
            let lastCard = entity.getLastCard();

            if (entity.cards.length > 0) {
                cards.push({ entity: entity, card: lastCard })
            }
        })

        cards.forEach(cardData => {
            cardData.entity.subscribeUserEventToCard(cardData.card,
                async (cardObj) => {

                    await this.gameCtx.moveCard(cardObj.owner, this.entityIndex, cardObj, true);
                    chosenCard = cardObj;

                    cardData.entity.resolvePlayer();
                }, Constants.FLAGS_SINGLE_TIME_USE);

            entityEvents.push(cardData.entity.waitForEvent());
            this.waitingEntities.push(cardData.entity)
        })

        await Promise.race(entityEvents);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_NEW_PILE_PICK_A_CARD);

        entities.forEach(entity => entity.unsubscribeEventToCards());

        if (this.lastReceivedCards[0] === chosenCard && chosenCard) {
            await this.onAfterPlayerGetCardFromNewPileOrUsedPile(chosenCard, this.entityIndex);
        }

        if (this.overrideAfterOnAfterPlayerGetCardFromNewPileOrUsedPile) {
            this.overrideAfterOnAfterPlayerGetCardFromNewPileOrUsedPile = false;
            await this.levelToSixCards();
            return this.userEventComplete;
        }

        this.addBubbleOnBottomPlayer("זרוק קלף", Constants.ELEMENT_MY_PLAYER_THROW_A_CARD);

        this.subscribeUserEventToCards(
            (cardObj) => { this.handleChooseCardEvent(cardObj) },
            Constants.FLAGS_MULTIPLE_TIME_USE);


        await this.waitForEvent();


        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_THROW_A_CARD);

        await this.gameCtx.moveCard(this.entityIndex, Constants.USED_PILE_INDEX, this.chosenCard, true);

        if (this.chosenCard) {
            await this.onAfterCardThrownFromPlayerToUsedPile(this.chosenCard);
        }

        await this.levelToSixCards();

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        this.resolvePlayerFinal(0);

        return this.userEventComplete;
    }

    handlePlayerStatusPopupClick = (val) => {
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_BUTTON);
        
        if (val === 0) {
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_BACKGROUND);
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_WINNING);
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_LOSING);
            NavTools.reload();
        }
        else {
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_BACKGROUND);
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_WINNING);
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_LOSING);
            NavTools.redirect(this.gameCtx.props, '/champions', { prevUrl: '/' })
        }
    }

    addPlayrStatusPopup = (playerStatus) => {
        let img = playerStatus === Constants.PLAYR_STATUS_WINNING ? 'winning' : 'losing';
        let text = playerStatus === Constants.PLAYR_STATUS_WINNING ? 'ניצחת!' : 'הפסדת!';

        const winningPopup =
            <div className="player-status-popup-box">
                <div className="player-status-popup">
                    <div className="popup-content">
                        <img alt="wining-img" className="player-status-img" src={require(`../../../media/images/icons/${img}.png`)} draggable="false" />
                        <div className="popup-text">
                            <div className="player-status-name">{this.getName()} {text}</div>
                            <div className="player-status-score">ניקוד: {this.score}</div>
                        </div>
                        <div className='popup-buttons'>
                            <img
                                alt="btn-continue-playing"
                                className="popup-btn-continue"
                                src={require('../../../media/images/icons/continue-play.png')}
                                onClick={() => this.handlePlayerStatusPopupClick(0)} />
                            <img
                                alt="btn-go-to-champions-page"
                                className="popup-btn-champions"
                                src={require('../../../media/images/icons/champions.png')}
                                onClick={() => this.handlePlayerStatusPopupClick(1)} />
                        </div>
                    </div>
                </div>
            </div>;

        this.gameCtx.elementsHandler.addElement(1000, winningPopup);
    }

    informWinning = () => {
        this.addPlayrStatusPopup(Constants.PLAYR_STATUS_WINNING);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_WINNING);
    }

    informLosing = () => {
        this.addPlayrStatusPopup(Constants.PLAYR_STATUS_LOSING);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_LOSING);
    }
}

export default UserPlayer;